// Structure prête pour brancher un outil analytics (GA4, Plausible, Pixel Meta...).
// Les événements sont poussés dans window.dataLayer : il suffira d'ajouter
// le script de l'outil choisi dans public/index.html.
export const trackEvent = (name, params = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...params });
};
